import api, { BodyParams } from "api";
import { useMutation } from "react-query";

const OP = "POST /invitations/patient";

export type Vars = BodyParams<typeof OP>;

const useInvitePatient = () => {
  return useMutation(({ email, payer_name, phone_country_code, phone_number, therapist_id }: Vars) =>
    api.parse(OP, {
      data: { email, payer_name, therapist_id, phone_country_code, phone_number },
    })
  );
};

export default useInvitePatient;
